/**
 * Which build this is.
 *
 * ⚠️ **Guarded, because these globals only exist after Vite's `define` has run.**
 * Referencing `__APP_VERSION__` directly throws `ReferenceError` anywhere the
 * bundler is not in the loop — every unit test, for a start, which is how this
 * was found. `typeof` on an undeclared identifier is the one safe way to ask,
 * so the question is asked once here rather than at each use.
 *
 * 'dev' rather than 'unknown': it is what a local build without git history
 * reports too, and one honest word beats two vocabularies for the same state.
 */
export const APP_VERSION: string = typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : 'dev';

export const BUILD_TIME: string = typeof __BUILD_TIME__ === 'string' ? __BUILD_TIME__ : '';

/**
 * "Sep 1, 04:42 PM" — when this bundle was built.
 *
 * Local time rather than UTC: the reader is asking "is this the build from
 * after my fix", and they know when they merged it in their own clock. An
 * absent or unparseable stamp yields nothing rather than "Invalid Date".
 */
export function formatBuildTime(iso: string = BUILD_TIME): string {
  if (!iso) return '';
  const at = new Date(iso);
  if (Number.isNaN(at.getTime())) return '';
  return at.toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/** "v2ea4743 · Sep 1, 04:42 PM", or just the version when there is no stamp. */
export function buildLabel(): string {
  const when = formatBuildTime();
  return when ? `v${APP_VERSION} · ${when}` : `v${APP_VERSION}`;
}
